import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class TransportItem extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'TransportItem';

    // Define default properties here
    static instanceDefaults() {
        return {
            content: '',
            content_tc: '',
            content_sc: '',
        }
    }
}

const servicePath = 'f-transport-items';
const servicePlugin = makeServicePlugin({
    Model: TransportItem,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin